module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupons"
  }, [_c('div', {
    staticClass: "coupons-table"
  }, [_c('div', {
    staticClass: "coupons-header"
  }, [_c('div', {
    staticClass: "coupons-header-t"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user_center_order_type')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('user_order_operation')))])])]), _vm._v(" "), _c('div', {
    staticClass: "coupons-body"
  }, [(_vm.coupons_num) ? _c('div', [_c('h1', {
    staticClass: "coupons-title"
  }, [_vm._v(_vm._s(_vm.$t('user_center_Coupons_useful_coupons')))]), _vm._v(" "), _vm._l((_vm.coupons), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "coupons-list"
    }, [_c('div', {
      staticClass: "coupons-type"
    }, [_c('div', {
      staticClass: "coupons-ticket",
      style: ({
        backgroundImage: 'url(' + require('../../assets/profile/coupons_valid.jpg') + ')'
      })
    }, [_c('div', {
      staticClass: "coupons-ticket-datil"
    }, [_vm._v("\n                                " + _vm._s(item.description) + "\n                            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "coupons-ticket-deadline"
    }, [_vm._v("\n                                " + _vm._s(_vm.$t('user_center_Coupons_death_time')) + ":" + _vm._s(item.exp_time) + "\n                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "coupons-operation"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Ticket_No')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.coupon_number))]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#0084ff"
      },
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.tip = true
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Use')))])])])
  })], 2) : _c('div', [_c('h1', {
    staticClass: "coupons-NO"
  }, [_vm._v(_vm._s(_vm.$t('no_records')))])]), _vm._v(" "), (_vm.overdue_num) ? _c('div', [_c('h1', {
    staticClass: "coupons-title"
  }, [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Overdue')))]), _vm._v(" "), _vm._l((_vm.overdue), function(items, index) {
    return _c('div', {
      key: index,
      staticClass: "coupons-list"
    }, [_c('div', {
      staticClass: "coupons-type"
    }, [_c('div', {
      staticClass: "coupons-ticket",
      style: ({
        backgroundImage: 'url(' + require('../../assets/profile/coupons_lapse.jpg') + ')'
      })
    }, [_c('div', {
      staticClass: "coupons-ticket-datil"
    }, [_vm._v("\n                                " + _vm._s(items.description) + "\n                            ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
      staticClass: "coupons-ticket-deadline"
    }, [_vm._v("\n                                " + _vm._s(_vm.$t('user_center_Coupons_death_time')) + ":" + _vm._s(items.exp_time) + "\n                            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "coupons-operation"
    }, [_c('p', [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Ticket_No')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(items.coupon_number))]), _vm._v(" "), _c('a', {
      staticStyle: {
        "color": "#D0021B"
      },
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Overdue')))])])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('modal', {
    staticClass: "tip",
    model: {
      value: (_vm.tip),
      callback: function($$v) {
        _vm.tip = $$v
      },
      expression: "tip"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header",
      "size": "small"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "tip-page"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('user_center_Coupons_Use_tips')))]), _vm._v(" "), _c('P', [_vm._v(_vm._s(_vm.$t('user_center_Coupons_use_Coupons')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "tip-button"
  }, [_c('button', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.tip = _vm.fasle
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel_btn')))]), _vm._v(" "), _c('button', {
    staticClass: "ok",
    on: {
      "click": _vm.download_iapp
    }
  }, [_vm._v(_vm._s(_vm.$t('download_btn')))])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cba5b09c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/Coupons.vue
// module id = 852
// module chunks = 0